/* eslint-disable jsx-a11y/media-has-caption */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { getVideoFromMicromag } from '../../lib/utils';

import styles from '../../../styles/partials/micromag-preview.module.scss';

const propTypes = {
    story: PropTypes.shape({}),
    isPoster: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    story: null,
    isPoster: false,
    className: null,
};

const MicromagVideo = ({ story, isPoster, className }) => {
    const video = getVideoFromMicromag(story);
    const { files = null, thumbnail_url: thumbnail = null } = video || {};
    const { h264 = null } = files || {};
    const { url = null } = h264 || {};

    return url !== null || thumbnail !== null ? (
        <video
            className={classNames([
                styles.container,
                styles.video,
                { [className]: className !== null },
            ])}
            src={!isPoster && url !== null ? `${url}#t=0.01` : null}
            poster={thumbnail}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
        />
    ) : null;
};

MicromagVideo.propTypes = propTypes;
MicromagVideo.defaultProps = defaultProps;

export default MicromagVideo;
